import { Component, OnInit, OnChanges,SimpleChanges,EventEmitter,Input,Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { I18Service } from '../../services/i18Service';
import { BaseService, LayoutService } from '../../../shared';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {Location} from '@angular/common';



@Component({
  selector: 'app-get-token',
  templateUrl: './get-token.component.html',
  styleUrls: ['./get-token.component.scss']
})
export class GetTokenComponent implements OnInit {
    private subscriptions: Subscription[] = [];

    constructor(
        private baseService: BaseService, public router: Router,private _location: Location

    ) { }

    ngOnInit(): void {
      this.GetMenuList();

    }
    menuList = [];
    GetMenuList() {
      let subscription = this.baseService.post('users/GenerateToken', {})
      .subscribe({
          next: (res: any) => {
              localStorage.setItem('token', res.output.UserJWT)
              this._location.back();
              // window.location.href = '/home';


                }
                , error: (error: string) => {
                     ;
                }
            });
        this.subscriptions.push(subscription);
    }



}







